import { i18nFilter } from "app/filters/i18nFilter";
import {
    minAbbrNumberFilter,
    numberFilter,
    percentageSignFilter,
    percentageSignOnlyOrZeroFilter,
    timeFilter,
} from "app/filters/ngFilters";
import { isGoogleAiModeAffectedChannel } from "pro-features/components/Chart/src/configs/plotLines/googleAiModeAnnotations";

export const getYaxisFormat = (metric: string, value: number, isPercentage: boolean) => {
    if (isPercentage) {
        return percentageSignOnlyOrZeroFilter()(value * 100, 0);
    }
    switch (metric) {
        case "TrafficShare":
            return minAbbrNumberFilter()(value);
        case "AverageDuration":
            return timeFilter()(value, null);
        case "PagesPerVisit":
            return numberFilter()(value, 2);
        case "BounceRate":
            return percentageSignFilter()(value, 2);
    }
};
export const getMetricTooltipHeader = (metric: string) => {
    switch (metric) {
        case "TrafficShare":
            return i18nFilter()("mmx.trafficshare.changetooltip.header");
        case "AverageDuration":
            return i18nFilter()("mmx.averageduration.changetooltip.header");
        case "PagesPerVisit":
            return i18nFilter()("mmx.pagespervisit.changetooltip.header");
        case "BounceRate":
            return i18nFilter()("mmx.bouncerate.changetooltip.header");
    }
};

/*
 * Compare mode plots a single channel picked in the segmented control, while single mode plots every
 * visible channel at once and the channel URL param silently stays on its "Direct" default
 */
export const shouldShowGoogleAiModeAnnotations = (
    isCompare: boolean,
    selectedChannel: string | undefined,
    visibleChannels: readonly string[],
): boolean =>
    isCompare
        ? isGoogleAiModeAffectedChannel(selectedChannel)
        : visibleChannels.some((channel) => isGoogleAiModeAffectedChannel(channel));
